import { CountryCode } from '../types/CountryCode';
import { LanguageCode } from '../types/LanguageCode';
import { Offer } from '../types/OfferTypes';

/**
 * Picks the translation key for an offer's toggle-card title. DK's MAX_CONSOLIDATION offer gets its own
 * "Fuld refinansiering" copy so it reads distinctly from REQUESTED_CONSOLIDATION's shared "Refinansiering" --
 * other markets keep the single shared consolidation title.
 *
 * `field.toggle.title.max-consolidation` only exists in translations_da.json -- translate() picks its file
 * by languageCode, not countryCode, so a DK flow in a non-Danish language (e.g. /en_DK/...) must not hit this
 * key or it renders as a raw, untranslated string. Requiring languageCode === DA keeps that combination on
 * the existing shared key instead.
 */
export function getOfferTitleTranslationKey(
    offerType: Offer['offerType'] | undefined,
    hasConsolidations: boolean,
    countryCode: CountryCode,
    languageCode: LanguageCode,
) {
    if (offerType === 'MAX_CONSOLIDATION' && countryCode === CountryCode.DK && languageCode === LanguageCode.DA) {
        return 'field.toggle.title.max-consolidation';
    }
    return hasConsolidations ? 'field.toggle.title.consolidation' : 'field.toggle.title.cash';
}
